import React from 'react';
import { FormattedMessage } from 'react-intl';
import { messages } from './messages';

export const PackageContentDescriptionLabel = () => <FormattedMessage {...messages.label} />;
